import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router'
import useSWR from 'swr'

import { PageHeader } from '@/components/ds'
import { Loading } from '@/components/Loading'
import { useSetPageHeader } from '@/contexts/PageHeaderContext'
import { apiFetcher } from '@/data/fetcher'
import { SendDocumentForm } from '@/forms/SendDocumentForm/SendDocumentForm'

export default function OrderSendPage() {
  const { id } = useParams()
  const { t } = useTranslation(undefined, {
    keyPrefix: 'order',
  })
  const { data: documentData, isLoading: ordersLoading } = useSWR(
    id && `/api/v2/orders/${id}`,
    apiFetcher,
  )
  const title = `Odeslat výzvu k platbě ${id}`

  useSetPageHeader({
    breadcrumbs: [
      {
        href: '/orders',
        children: t('list.title'),
      },
      {
        href: `/order/${id}`,
        children: id as string,
      },
      {
        href: `/order/${id}/send`,
        children: t('send.breadcrumb'),
      },
    ],
  })

  return (
    <>
      <title>{title}</title>

      {ordersLoading && <Loading />}

      <div className="mx-auto w-full max-w-[1280px]">
        <PageHeader
          title={title}
          description={
            documentData?.customer?.name
              ? `Pro ${documentData.customer.name}`
              : undefined
          }
        />
        {documentData && (
          <SendDocumentForm
            type="order"
            uuid={documentData.uuid}
            symbol={documentData.symbol}
            summary={{
              supplierName: documentData.supplier?.name,
              amount: (documentData.items ?? []).reduce(
                (sum: number, item: { totalPrice?: { amount?: string } }) =>
                  sum + Number(item.totalPrice?.amount ?? 0),
                0,
              ),
              currency: documentData.currency ?? 'CZK',
              deadlineAt: documentData.deadlineAt,
            }}
            defaultValues={{
              subject: t('send.form.subject.default', {
                symbol: documentData?.symbol,
                name: documentData?.supplier?.name,
              }),
              recipient: documentData?.customer?.email || '',
              cc: '',
              message: t('send.form.message.default', {
                symbol: documentData?.symbol,
                name: documentData?.supplier?.name,
              }),
            }}
          />
        )}
      </div>
    </>
  )
}
